import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TreeMixin, itemTypeLoadMore, itemTypeDefault } from './mixin';
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import clone from 'lodash/clone';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinTreeSelection',
  mixins: [TreeMixin],
  props: {
    searchEnabled: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    loadStates: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    },
    selectedTwins: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      statesForTwins: {}
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])),
  watch: {
    selectedTwins: function selectedTwins() {
      this.cleanTreeSelection();
    }
  },
  created: function created() {
    this.loadDescendents = false;
    this.itemTypeLoadMore = itemTypeLoadMore;
  },
  mounted: function mounted() {
    this.initTree();
  },
  methods: {
    initTree: function initTree() {
      this.twinTreeItems = [];
      this.twinItemMapping = {};
      this.twinItemMapping[this.parentId] = {}; // an active node is specified, so make sure to load the tree-structure to accomodate this node
      // might not be on root-level, so there is special handling required to have it displayed right away

      if (this.activeDtwinId) {
        this.fetchPartialTree(this.activeDtwinId);
      } else {
        this.fetchChildren({
          id: this.parentId
        }, true);
      }
    },
    fetchChildren: function fetchChildren(item) {
      var initially = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.fetchChildrenDefault(item.id, 0, initially);
    },
    cleanTreeSelection: function cleanTreeSelection() {
      var _this = this;

      var iterateChildren = function iterateChildren(children) {
        children.forEach(function (child) {
          if (child.id && typeof child.id !== 'string') {
            if (_this.selectedTwins.findIndex(function (t) {
              return t.id === child.id;
            }) < 0) {
              child.selected = false;
            }
          } else {
            if (child.children) {
              iterateChildren(child.children);
            }
          }
        });
      };

      iterateChildren(this.twinTreeItems); // force a refresh

      this.twinTreeItems = clone(this.twinTreeItems);
    },
    processTreeItems: function processTreeItems(items) {
      var _this2 = this;

      // fetch all states for each twin (no UI-output yet, tho)
      return this.processTreeItemsStates(items).then(function () {
        return _this2.processTreeItemsDefault(items);
      });
    },
    itemType: function itemType(item) {
      var itemId = get(item, 'id');

      if (typeof itemId === 'string') {
        if (itemId.startsWith(itemTypeLoadMore)) {
          return itemTypeLoadMore;
        }
      }

      return itemTypeDefault;
    },
    getTwinTreeIcon: function getTwinTreeIcon(dtwin) {
      // special case for the "Load More" tree item
      if (this.itemType(dtwin) === itemTypeLoadMore) {
        return this.getTwinTreeIconDefault(dtwin);
      } // return this.getTwinTreeIconStates(dtwin);


      return this.getTwinTreeIconDefault(dtwin);
    },
    // --------
    // STATES
    // --------
    fetchBindingsForTwinIds: function fetchBindingsForTwinIds(twinIds) {
      var _this3 = this;

      var twinIdsToBeFetched = twinIds.filter(function (twinId) {
        return !_this3.statesForTwins[twinId];
      });

      if (twinIdsToBeFetched.length > 0) {
        twinIdsToBeFetched.forEach(function (id) {
          if (!_this3.statesForTwins[id]) {
            _this3.statesForTwins[id] = [];
          }
        });
        return ApiService.digitalTwinsFetchStates(this, twinIdsToBeFetched, ['bare']).then(function (states) {
          states.forEach(function (state) {
            _this3.statesForTwins[state.dtwinId].push(state);
          });
          _this3.twinTreeItems = clone(_this3.twinTreeItems);
        });
      }

      return Promise.resolve();
    },
    processTreeItemsStates: function processTreeItemsStates(items) {
      var _this4 = this;

      if (!this.loadStates) {
        return Promise.resolve();
      }

      var fetchStatesForTwinIds = [];
      items.forEach(function (item) {
        if (item.id && typeof item.id !== 'string') {
          _this4.twinItemMapping[item.id] = item;
          fetchStatesForTwinIds.push(item.id);
        }
      });
      return this.fetchBindingsForTwinIds(fetchStatesForTwinIds);
    },
    twinSelectionToggled: function twinSelectionToggled(item) {
      var cleanItem = cloneDeep(item);

      if (this.twinIsSelected(cleanItem)) {
        // remove from list
        this.$emit('deselectedTwin', cleanItem);
      } else {
        // add to list
        this.$emit('selectedTwin', cleanItem);
      }
    },
    twinIsSelected: function twinIsSelected(item) {
      return this.selectedTwins.findIndex(function (selectedTwin) {
        return selectedTwin.id === item.id;
      }) >= 0;
    }
  }
};